// levelUpBus — tiny event bus so the global points-gain hook can trigger the
// LevelUpCelebration overlay without prop drilling. Fire-and-forget; the
// overlay subscribes once at app root and renders on demand.
//
// Why not just render inside useXPGainToasts? The hook lives next to the
// app-level toasters but doesn't render any UI. Keeping the celebration in
// its own component lets us animate, focus-trap, and unmount cleanly.

export type LevelUpDetail = {
  level: number;
  tierLabel: string;
  pointsGained: number;
};

const EVENT = "hackerlab:level-up";

export const fireLevelUp = (detail: LevelUpDetail) => {
  window.dispatchEvent(new CustomEvent<LevelUpDetail>(EVENT, { detail }));
};

export const onLevelUp = (handler: (detail: LevelUpDetail) => void) => {
  const wrapped = (e: Event) => handler((e as CustomEvent<LevelUpDetail>).detail);
  window.addEventListener(EVENT, wrapped);
  return () => window.removeEventListener(EVENT, wrapped);
};
